var map = {
	"./google-laurel-da-DK.svg": 64460,
	"./google-laurel-de-DE.svg": 94302,
	"./google-laurel-en-GB.svg": 53284,
	"./google-laurel-en-US.svg": 88847,
	"./google-laurel-es-ES.svg": 936,
	"./google-laurel-es-MX.svg": 53979,
	"./google-laurel-fr-FR.svg": 11968,
	"./google-laurel-it-IT.svg": 13366,
	"./google-laurel-nb-NO.svg": 23341,
	"./google-laurel-nl-NL.svg": 12380,
	"./google-laurel-pl-PL.svg": 36692,
	"./google-laurel-pt-BR.svg": 23016,
	"./google-laurel-pt-PT.svg": 98740,
	"./google-laurel-sv-SE.svg": 80997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39909;